<template>
  <div class="register-page">
    <a-row style="margin: 6px 0">
      <a-col :span="24">
        <!-- ✅ 使用 FormModel，并挂 rules -->
        <a-form-model ref="formRef" :model="form" :rules="rules">
          <!-- 标题 -->
          <h2 class="title">设置企业密码</h2>

          <!-- 密码 -->
          <a-form-model-item prop="password" style="margin-bottom: 20px">
            <a-input-password
              v-model="form.password"
              placeholder="请输入切换密码"
            >
              <a-icon
                slot="prefix"
                type="lock"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input-password>
          </a-form-model-item>

          <!-- 确认密码 -->
          <a-form-model-item prop="confirmPassword" style="margin-bottom: 20px">
            <a-input-password
              v-model="form.confirmPassword"
              placeholder="请再次输入密码"
            >
              <a-icon
                slot="prefix"
                type="lock"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input-password>
          </a-form-model-item>

          <!-- 注册按钮（仅点击触发） -->
          <a-form-model-item>
            <a-button
              style="width: 100%"
              size="large"
              type="primary"
              class="register-button"
              :loading="state.buttonLoading"
              @click="handleConfirm"
            >
              设置
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { createCompany } from "@/api/company/Company.js";
export default {
  props: {
    businessLicenseInfo: {
      type: Object,
      default: () => null,
    },
    authorizationDocumentInfo: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      state: {
        buttonLoading: false,
      },
      form: { password: "", confirmPassword: "" },
      rules: {
        password: [
          {
            validator: (rule, value, callback) =>
              this.validatePasswordComplexity(rule, value, callback),
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, message: "请确认密码！", trigger: "blur" },
          {
            validator: (rule, value, callback) =>
              this.validateConfirmPassword(rule, value, callback),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    /** ✅ 密码复杂度校验 */
    validatePasswordComplexity(rule, value, callback) {
      if (!value) return callback("请输入密码！");

      // 1️⃣ 长度校验
      if (value.length < 8 || value.length > 20) {
        return callback("密码长度需为 8-20 位！");
      }

      // 2️⃣ 必须包含大写、小写、数字、特殊符号
      const upper = /[A-Z]/;
      const lower = /[a-z]/;
      const digit = /[0-9]/;
      const special =
        /[~!@#$%^&*()_\-+=<>?{}[\]|:;"',./`￥！……（）—【】、；‘’，。《》？]/;

      if (
        !upper.test(value) ||
        !lower.test(value) ||
        !digit.test(value) ||
        !special.test(value)
      ) {
        return callback("密码需包含大写字母、小写字母、数字和特殊符号！");
      }
      4;
      return callback();
    },

    /** ✅ 确认密码一致性（原逻辑保留，rules 中调用它） */
    validateConfirmPassword(rule, value, callback) {
      if (value && value !== this.form.password) {
        callback("两次输入的密码不一致！");
      } else {
        callback();
      }
    },

    handleConfirm() {
      this.$refs.formRef.validate((valid) => {
        const businessLicenseUrl = this.businessLicenseInfo.businessLicense.map(
          (item) => item.url
        );
        const companyAuthorizationUrl =
          this.authorizationDocumentInfo.companyAuthorization.map(
            (item) => item.url
          );
        if (valid) {
          this.state.buttonLoading = true;
          createCompany({
            ...this.businessLicenseInfo,
            ...this.authorizationDocumentInfo,
            businessLicenseUrl,
            companyAuthorizationUrl,
            password: this.form.password,
            confirmPassword: this.form.confirmPassword,
          })
            //登入失败在这里改动
            .then((res) => this.createSuccess(res))
            .catch((err) => this.requestFailed(err))
            .finally(() => {});
        }
      });
    },

    createCompany() {
      this.$emit("createCompany");
    },

    createSuccess(res) {
      if (res.code == "200") {
        setTimeout(() => {
          this.$notification.success({
            message: `提交成功`,
            description: `请等待审核结果`,
          });
          this.state.buttonLoading = false;
          this.$emit("nextStep");
        }, 500);
      } else {
        setTimeout(() => {
          this.state.buttonLoading = false;
          this.$notification["error"]({
            message: "错误",
            description: res.msg,
          });
        }, 500);
      }
    },
    //服务器报错时发生
    requestFailed(err) {
      setTimeout(() => {
        this.state.buttonLoading = false;
        this.$notification["error"]({
          message: "错误",
          description:
            ((err.response || {}).data || {}).message || "网络异常，请稍后再试",
          duration: 4,
        });
      }, 500);
    },
  },
};
</script>

<style scoped>
.switch-wrapper {
  padding: 10px 20px 0 20px;
}

.title {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 30px;
}

/* 用户名行 */
.info-row {
  margin: 12px 0;
  display: flex;
  align-items: center;
}

/* 密码行整体 */
.password-row {
  display: flex;
  align-items: flex-start; /* ⭐ 确保忘记密码不下沉 */
  margin: 12px 0;
}

.label {
  width: 70px;
  font-size: 14px;
  color: #333;
  line-height: 32px;
}

.label.required::before {
  content: "*";
  color: #ff4d4f;
  margin-right: 4px;
}

/* 右侧整体区域（输入框 + 错误提示 + 忘记密码） */
.password-content {
  flex: 1;
  display: flex;
  align-items: flex-start;
}

/* 让 form-item 占据左侧 */
.password-item {
  flex: 1;
  margin-bottom: 0; /* 避免多余空白 */
}

/* 忘记密码 */
.forget-link {
  margin-left: 10px;
  /* white-space: nowrap; */
  font-size: 13px;
  /* cursor: pointer; */
  line-height: 40px; /* ⭐ 永远与输入框在一条线上 */
}

/* 按钮行 */
.btn-row {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  gap: 20px;
}

.btn-cancel {
  border: 1px solid #d9d9d9;
}

/* 输入框高度统一 */
.password-item /deep/ .ant-input {
  height: 32px !important;
  border-radius: 4px;
}
</style>
